package com.nikolastojiljkovic.dotty.compiler.shared

import io.circe.Codec

case class CompilationDiagnostic(range: CompilationRange, severity: Int, code: String, source: String, message: String) derives Codec.AsObject
